module.exports = __webpack_public_path__ + "media/images/ir/common/footer_r-img-88aba43d2a9650cad087ba84a20af610.svg";